<div kalDialogContent>
    <app-shared-comment-edit [disabledPrivateComment]="data?.disabledPrivateComment"
                             [disabledPublicComment]="data?.disabledPublicComment"
                             [formControl]="commentControl"
                             [privateCommentLabel]="data?.privateCommentLabel"
                             [privateCommentValidators]="data?.privateCommentValidators"
                             [publicCommentLabel]="data?.publicCommentLabel"
                             [publicCommentValidators]="data?.publicCommentValidators"
                             isOpened>
    </app-shared-comment-edit>
</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="submit()"
                        id="shared-add-comment-dialog_submit"
                        kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        id="shared-add-comment-dialog_cancel"
                        kalTheme="secondary">
                Fermer
            </kal-button>

        </div>

    </div>

</div>
